import {Moment} from 'moment';

export type Datepicker2Value = Moment | null;
